import { useBranding } from '@/hooks/useBranding';
import RestaurantLogo from '@/components/branding/RestaurantLogo';

export type AdminTab = 'menu' | 'extras' | 'slider' | 'homepage' | 'branding' | 'settings';

interface AdminSidebarProps {
  activeTab: AdminTab;
  onTabChange: (tab: AdminTab) => void;
  onLogout: () => void;
}

const navItems: { id: AdminTab; label: string; icon: string }[] = [
  { id: 'menu', label: 'Menü Yönetimi', icon: 'ri-restaurant-line' },
  { id: 'extras', label: 'Ekstralar', icon: 'ri-add-circle-line' },
  { id: 'slider', label: 'Ana Sayfa Slider', icon: 'ri-slideshow-3-line' },
  { id: 'homepage', label: 'Ana Sayfa İçeriği', icon: 'ri-layout-line' },
  { id: 'branding', label: 'Markalama & Medya', icon: 'ri-palette-line' },
  { id: 'settings', label: 'Ayarlar', icon: 'ri-settings-3-line' },
];

const AdminSidebar = ({ activeTab, onTabChange, onLogout }: AdminSidebarProps) => {
  const { restaurantName } = useBranding();

  return (
  <aside className="w-64 min-h-screen bg-gray-950 flex flex-col">
    <div className="px-6 py-6 border-b border-white/10">
      <RestaurantLogo maxHeight={72} invert />
      <p className="text-gray-500 text-xs mt-2 font-medium tracking-wide uppercase">{restaurantName || 'Yönetici Paneli'}</p>
    </div>

    <nav className="flex-1 px-3 py-4 flex flex-col gap-1">
      {navItems.map((item) => {
        const isActive = activeTab === item.id;
        return (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all cursor-pointer whitespace-nowrap text-left
              ${isActive
                ? 'bg-orange-500 text-white'
                : 'text-gray-400 hover:bg-white/5 hover:text-white'
              }`}
          >
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className={`${item.icon} text-base`}></i>
            </div>
            {item.label}
          </button>
        );
      })}
    </nav>

    <div className="px-3 py-4 border-t border-white/10">
      <button
        onClick={onLogout}
        className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-gray-400 hover:bg-red-500/10 hover:text-red-400 transition-all cursor-pointer whitespace-nowrap"
      >
        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
          <i className="ri-logout-box-line text-base"></i>
        </div>
        Çıkış Yap
      </button>
    </div>
  </aside>
  );
};

export default AdminSidebar;
